import { CommonModule, Location } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs';
import { TranslocoModule } from '@jsverse/transloco';
import { GoogleAnalyticsService } from 'src/app/shared/service/google-analytics.service';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        MatTab,
        MatTabGroup,
        MatTabLabel,
        MatCard,
        MatIcon,
        TranslocoModule,
        FlexLayoutModule,
        MatButtonModule
    ]
})
export class PrivacyPolicyComponent implements OnInit {
    panelOpenState = false;
    constructor(
        private _location: Location,
        private _googleAnalyticsService: GoogleAnalyticsService
    ) {}

    ngOnInit(): void {
        this._googleAnalyticsService.pageView('Privacy Policy');
    }

    goBack() {
        this._location.back();
    }
}
